/*! ypresets-restricted-video.js
 * 1) ALWAYS: keep HTML videos muted + inline (playsinline / webkit-playsinline),
 *    never force native controls, exit iOS fullscreen if it tries to take over.
 *    Normal Safari/Chrome autoplay stays on.
 * 2) TikTok in-app WebView ONLY: neutralize play(),
 *    freeze on poster, show interstitial with ··· → Open in Browser steps (no fake Safari button).
 *    Instagram / Facebook / other in-apps are NOT restricted — normal video.
 *    Cannot force-escape TikTok — WKWebView blocks auto scheme redirects.
 */
(function () {
  'use strict';

  var RE =
    /tiktok|musical_ly|bytedancewebview|ttwebview/i;

  var ua = '';
  try {
    ua = navigator.userAgent || navigator.vendor || '';
  } catch (e) {}

  var restricted = RE.test(ua);
  var isIOS = /iPhone|iPad|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /Android/i.test(ua);
  var isTikTok = /tiktok|musical_ly|bytedancewebview|ttwebview/i.test(ua);
  var isInstagram = /instagram/i.test(ua);

  try {
    window.YP_RESTRICTED_INLINE_VIDEO = restricted;
  } catch (e2) {}

  function prepareInlineVideo(video) {
    if (!video || video.nodeName !== 'VIDEO') return video;
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
    } catch (e) {}
    try {
      if (!video.hasAttribute('muted')) video.setAttribute('muted', '');
      if (!video.hasAttribute('playsinline')) video.setAttribute('playsinline', '');
      if (!video.hasAttribute('webkit-playsinline')) video.setAttribute('webkit-playsinline', '');
      if (!video.hasAttribute('x-webkit-airplay')) video.setAttribute('x-webkit-airplay', 'allow');
    } catch (e2) {}
    if (!video.classList.contains('yp-show-controls')) {
      try {
        if (video.controls) video.controls = false;
        if (video.hasAttribute('controls')) video.removeAttribute('controls');
        if (!video.hasAttribute('controlslist')) {
          video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        }
        if (!video.hasAttribute('disablepictureinpicture')) {
          video.setAttribute('disablepictureinpicture', '');
        }
        if ('disablePictureInPicture' in video) video.disablePictureInPicture = true;
      } catch (e3) {}
    }
    try { video.setAttribute('data-yp-inline-ok', '1'); } catch (eOk) {}
    if (!video.getAttribute('data-yp-fs-guard')) {
      video.setAttribute('data-yp-fs-guard', '1');
      var exitFs = function () {
        try {
          if (typeof video.webkitExitFullscreen === 'function') video.webkitExitFullscreen();
        } catch (e4) {}
        try {
          if (typeof video.exitFullscreen === 'function') video.exitFullscreen();
        } catch (e5) {}
        try {
          if (document.fullscreenElement === video && document.exitFullscreen) {
            document.exitFullscreen();
          }
        } catch (e6) {}
      };
      video.addEventListener('webkitbeginfullscreen', function (ev) {
        try { if (ev && ev.preventDefault) ev.preventDefault(); } catch (e7) {}
        exitFs();
        setTimeout(exitFs, 0);
        setTimeout(exitFs, 50);
      });
      video.addEventListener('fullscreenchange', function () {
        if (document.fullscreenElement === video) exitFs();
      });
      video.addEventListener('webkitfullscreenchange', function () {
        try {
          if (video.webkitDisplayingFullscreen) exitFs();
        } catch (e8) {}
      });
      video.addEventListener('webkitpresentationmodechanged', function () {
        try {
          if (video.webkitPresentationMode && video.webkitPresentationMode !== 'inline') {
            video.webkitSetPresentationMode('inline');
          }
        } catch (e9) {}
      });
    }
    return video;
  }

  try {
    window.YP_PREPARE_INLINE_VIDEO = prepareInlineVideo;
  } catch (e10) {}

  function prepareAll(scope) {
    var list = (scope || document).querySelectorAll('video');
    for (var i = 0; i < list.length; i++) prepareInlineVideo(list[i]);
  }

  function bootInline() {
    prepareAll(document);
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && m.target && m.target.nodeName === 'VIDEO') {
            if ((m.attributeName === 'playsinline' || m.attributeName === 'webkit-playsinline') &&
                !m.target.hasAttribute(m.attributeName)) {
              prepareInlineVideo(m.target);
            }
            continue;
          }
          var nodes = m.addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.nodeName === 'VIDEO') prepareInlineVideo(n);
            else if (n.querySelectorAll) prepareAll(n);
          }
        }
      });
      mo.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['playsinline', 'webkit-playsinline']
      });
    }
  }

  if (document.readyState === 'loading') {
    var early = setInterval(function () {
      if (document.body) {
        clearInterval(early);
        prepareAll(document);
      }
    }, 20);
    setTimeout(function () { clearInterval(early); }, 4000);
    document.addEventListener('DOMContentLoaded', bootInline, { once: true });
  } else {
    bootInline();
  }

  if (!restricted) return;

  var nativePlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    try {
      this.pause();
    } catch (e) {}
    var err = new DOMException(
      'Restricted in-app browser: inline video blocked',
      'NotAllowedError'
    );
    var rejected = Promise.reject(err);
    rejected.catch(function () {});
    return rejected;
  };
  try {
    window.YP_NATIVE_MEDIA_PLAY = nativePlay;
  } catch (e11) {}

  function freezeVideo(video) {
    if (!video || video.nodeName !== 'VIDEO') return;
    prepareInlineVideo(video);
    try {
      video.removeAttribute('autoplay');
      video.autoplay = false;
    } catch (e) {}
    try {
      video.pause();
    } catch (e3) {}
    try {
      video.removeAttribute('data-yp-playing-ok');
      video.removeAttribute('data-yp-ready');
      var root = video.closest('[data-yp-video], deferred-media, .video-section__media');
      if (root) root.removeAttribute('data-yp-ready');
    } catch (e4) {}
  }

  function freezeAll(scope) {
    var list = (scope || document).querySelectorAll('video');
    for (var i = 0; i < list.length; i++) freezeVideo(list[i]);
  }

  function pageUrl() {
    try {
      return location.href.split('#')[0];
    } catch (e) {
      return 'https://www.ypresets.com/';
    }
  }

  function iosSafariScheme(url) {
    // Private Apple scheme: x-safari-https://host/path (no :// after x-safari-)
    return 'x-safari-' + url;
  }

  function androidIntentUrl(url) {
    try {
      var u = new URL(url);
      return (
        'intent://' +
        u.host +
        u.pathname +
        u.search +
        '#Intent;scheme=https;S.browser_fallback_url=' +
        encodeURIComponent(url) +
        ';end'
      );
    } catch (e) {
      return url;
    }
  }

  function instagramExtBrowser(url) {
    return 'instagram://extbrowser/?url=' + encodeURIComponent(url);
  }

  function fallbackCopy(text, done) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      ta.setSelectionRange(0, text.length);
      document.execCommand('copy');
      ta.remove();
      if (done) done(true);
    } catch (e) {
      if (done) done(false);
    }
  }

  function copyUrl(url, done) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (done) done(true);
        }).catch(function () {
          fallbackCopy(url, done);
        });
        return;
      }
    } catch (e) {}
    fallbackCopy(url, done);
  }

  function tryOpenExternal(url) {
    // Must run inside a user tap. TikTok blocks JS auto-redirects;
    // even gesture-based x-safari-/intent: often no-ops. Never replace
    // location on TikTok — a rejected scheme can blank the WebView.
    var targets = [];
    if (isInstagram && isIOS) {
      targets.push(instagramExtBrowser(url));
    }
    if (isIOS) {
      targets.push(iosSafariScheme(url));
      try {
        targets.push(url.replace(/^https:\/\//i, 'googlechromes://').replace(/^http:\/\//i, 'googlechrome://'));
      } catch (e) {}
    } else if (isAndroid) {
      targets.push(androidIntentUrl(url));
      try {
        targets.push(url.replace(/^https:\/\//i, 'googlechromes://').replace(/^http:\/\//i, 'googlechrome://'));
      } catch (e2) {}
    }

    function clickHref(href) {
      try {
        var a = document.createElement('a');
        a.setAttribute('href', href);
        a.setAttribute('rel', 'noopener');
        a.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { try { a.remove(); } catch (e) {} }, 0);
        return true;
      } catch (e3) {
        return false;
      }
    }

    for (var i = 0; i < targets.length; i++) {
      clickHref(targets[i]);
    }

    // Android (non-TikTok especially): top-level intent:// often hands off.
    // Skip on TikTok to avoid a stuck/blank WebView if the scheme is ignored.
    if (isAndroid && !isTikTok && targets.length) {
      try {
        window.location.href = targets[0];
        return;
      } catch (e4) {}
    }

    try {
      window.open(url, '_blank');
    } catch (e5) {}
  }

  function injectInterstitial() {
    if (document.getElementById('yp-rv-interstitial')) return;
    try {
      if (sessionStorage.getItem('ypRvInterstitialDismissed') === '1') {
        injectMiniHint();
        return;
      }
    } catch (e) {}

    var appName = isTikTok ? 'TikTok' : isInstagram ? 'Instagram' : 'this app';

    var wrap = document.createElement('div');
    wrap.id = 'yp-rv-interstitial';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'yp-rv-title');
    wrap.innerHTML =
      '<div class="yp-rv-card">' +
      '<h2 id="yp-rv-title">Videos won’t play inside ' + appName + '</h2>' +
      '<p class="yp-rv-body">Open this page in your browser to watch the demos.</p>' +
      '<div class="yp-rv-steps">' +
      '<p class="yp-rv-steps-title">How to open</p>' +
      '<ol>' +
      '<li>Tap <strong>···</strong> at the top</li>' +
      '<li>Choose <strong>Open in Browser</strong></li>' +
      '</ol>' +
      '</div>' +
      '<button type="button" class="yp-rv-continue" id="yp-rv-continue">Continue with still images</button>' +
      '</div>';

    var style = document.createElement('style');
    style.id = 'yp-rv-interstitial-css';
    style.textContent =
      '#yp-rv-interstitial{position:fixed;inset:0;z-index:99995;display:flex;align-items:flex-end;justify-content:center;' +
      'padding:16px 16px max(16px,env(safe-area-inset-bottom));' +
      'background:rgba(12,12,12,.55);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased}' +
      '#yp-rv-interstitial .yp-rv-card{width:100%;max-width:420px;background:#f7f4ef;color:#1a1a1a;border-radius:20px;' +
      'padding:22px 20px 18px;box-shadow:0 18px 50px rgba(0,0,0,.35)}' +
      '#yp-rv-interstitial h2{margin:0 0 8px;font-size:22px;line-height:1.2;font-weight:700;letter-spacing:-.02em}' +
      '#yp-rv-interstitial .yp-rv-body{margin:0 0 14px;font-size:15px;line-height:1.45;color:#3a3632}' +
      '#yp-rv-interstitial .yp-rv-steps{margin:0 0 14px;padding:14px 16px;border-radius:12px;background:rgba(26,26,26,.05)}' +
      '#yp-rv-interstitial .yp-rv-steps-title{margin:0 0 8px;font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#6b6560}' +
      '#yp-rv-interstitial ol{margin:0;padding-left:18px;font-size:15px;line-height:1.55;color:#1a1a1a}' +
      '#yp-rv-interstitial li{margin:0 0 4px}' +
      '#yp-rv-interstitial .yp-rv-continue{appearance:none;width:100%;border:0;background:transparent;color:#6b6560;' +
      'font:500 13.5px/1.3 inherit;padding:8px;cursor:pointer;text-decoration:underline;text-underline-offset:2px}' +
      '#yp-rv-interstitial .yp-rv-continue:active{opacity:.82}' +
      '@media (min-width:720px){#yp-rv-interstitial{align-items:center}}';

    function mount() {
      if (!document.head || !document.body) return false;
      if (!document.getElementById('yp-rv-interstitial-css')) document.head.appendChild(style);
      if (!document.getElementById('yp-rv-interstitial')) document.body.appendChild(wrap);
      return true;
    }

    if (!mount()) {
      document.addEventListener('DOMContentLoaded', function () { mount(); }, { once: true });
    }

    function dismiss(keepMini) {
      wrap.remove();
      try { sessionStorage.setItem('ypRvInterstitialDismissed', '1'); } catch (e) {}
      if (keepMini) injectMiniHint();
    }

    wrap.querySelector('#yp-rv-continue').addEventListener('click', function (ev) {
      ev.preventDefault();
      dismiss(true);
    });
  }

  function injectMiniHint() {
    if (document.getElementById('yp-restricted-video-hint') || document.getElementById('yp-rv-interstitial')) return;
    try {
      if (sessionStorage.getItem('ypRvHintDismissed') === '1') return;
    } catch (e) {}

    var labelText = 'Tap ··· → Open in Browser';

    var bar = document.createElement('div');
    bar.id = 'yp-restricted-video-hint';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<button type="button" class="yp-rv-hint__action" aria-label="How to open in your browser">' +
      '<span class="yp-rv-hint__label"></span>' +
      '</button>' +
      '<button type="button" class="yp-rv-hint__close" aria-label="Dismiss">&times;</button>';
    bar.querySelector('.yp-rv-hint__label').textContent = labelText;

    var style = document.createElement('style');
    style.id = 'yp-restricted-video-hint-css';
    style.textContent =
      '#yp-restricted-video-hint{position:fixed;top:max(12px,env(safe-area-inset-top,0px));left:50%;transform:translateX(-50%);' +
      'z-index:99990;display:flex;align-items:center;gap:8px;' +
      'max-width:calc(100vw - 28px);padding:9px 10px 9px 14px;' +
      'background:rgba(24,24,24,.92);color:#f4f4f2;' +
      'border:1px solid rgba(255,255,255,.08);border-radius:999px;' +
      'box-shadow:0 8px 28px rgba(0,0,0,.28);' +
      'font:500 12.5px/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;' +
      'letter-spacing:.01em;-webkit-font-smoothing:antialiased;' +
      'backdrop-filter:saturate(140%) blur(10px);-webkit-backdrop-filter:saturate(140%) blur(10px)}' +
      '#yp-restricted-video-hint .yp-rv-hint__action{appearance:none;background:transparent;border:0;padding:0;margin:0;cursor:pointer;' +
      'color:inherit;font:inherit;text-align:left;display:flex;align-items:center;gap:8px;min-width:0}' +
      '#yp-restricted-video-hint .yp-rv-hint__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '#yp-restricted-video-hint .yp-rv-hint__action:after{content:"";width:5px;height:5px;border-right:1.5px solid rgba(244,244,242,.7);' +
      'border-top:1.5px solid rgba(244,244,242,.7);transform:rotate(45deg);flex:0 0 auto}' +
      '#yp-restricted-video-hint .yp-rv-hint__close{appearance:none;background:rgba(255,255,255,.08);border:0;color:#f4f4f2;' +
      'width:26px;height:26px;border-radius:50%;cursor:pointer;flex:0 0 auto;' +
      'font:500 16px/1 -apple-system,BlinkMacSystemFont,sans-serif;padding:0;' +
      'display:inline-flex;align-items:center;justify-content:center}' +
      '#yp-restricted-video-hint .yp-rv-hint__close:active,#yp-restricted-video-hint .yp-rv-hint__action:active{opacity:.72}';

    function mount() {
      if (!document.head || !document.body) return false;
      if (!document.getElementById('yp-restricted-video-hint-css')) document.head.appendChild(style);
      if (!document.getElementById('yp-restricted-video-hint')) document.body.appendChild(bar);
      return true;
    }
    if (!mount()) {
      document.addEventListener('DOMContentLoaded', function () { mount(); }, { once: true });
    }

    bar.querySelector('.yp-rv-hint__close').addEventListener('click', function (ev) {
      ev.preventDefault();
      bar.remove();
      try { sessionStorage.setItem('ypRvHintDismissed', '1'); } catch (e) {}
    });

    bar.querySelector('.yp-rv-hint__action').addEventListener('click', function (ev) {
      ev.preventDefault();
      var label = bar.querySelector('.yp-rv-hint__label');
      if (label) {
        label.textContent = 'Use ··· at the top of ' + (isTikTok ? 'TikTok' : isInstagram ? 'Instagram' : 'the app');
        setTimeout(function () {
          if (label && bar.isConnected) label.textContent = labelText;
        }, 2200);
      }
    });
  }

  function bootRestricted() {
    freezeAll(document);
    injectInterstitial();
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && m.target && m.target.nodeName === 'VIDEO') {
            freezeVideo(m.target);
            continue;
          }
          var nodes = m.addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.nodeName === 'VIDEO') freezeVideo(n);
            else if (n.querySelectorAll) freezeAll(n);
          }
        }
      });
      mo.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['autoplay', 'controls']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRestricted, { once: true });
    var earlyR = setInterval(function () {
      if (document.body) {
        clearInterval(earlyR);
        freezeAll(document);
        injectInterstitial();
      }
    }, 40);
    setTimeout(function () { clearInterval(earlyR); }, 4000);
  } else {
    bootRestricted();
  }
})();
